
import Verify from '../utils/verify'

import ChinaAddressV2Data from '../data/AddressData2016'

import qs from 'qs'
import types from '../store/mutation-types'
import getAgeAndSexFromID from '../utils/getAgeAndSexFromID'
import formatDate from '../utils/formatDate'
import isAgeIn from '../utils/isAgeIn'

export default {
name: 'm-form',
mounted () {
document.title = '填写投保信息'
this.$http.get('https://m.wkbins.com/explosions/static/common/js/tongji.txt?where=form&productCode=' + this.$store.state.app.productCode + '&innerCode=' + this.$store.state.app.innerCode + '&utm_source=' + (this.$route.query.utm_source || '')).then(response => {
})
if (this.$store.state.app.productCode === '150634119420883220' || this.$store.state.app.productCode === '150631164164706555') {
const formDate = JSON.parse(sessionStorage.getItem('data'))
console.log(formDate)
if (formDate) {
setTimeout(() => {
this.$store.commit(types.UPDATE_HOLDERNAME, formDate['policyHolder.holderName'])
this.$store.commit(types.UPDATE_HOLDERIDNUMBER, formDate['policyHolder.holderIdNumber'])
this.$store.commit(types.UPDATE_ISHOLDERIDLONGTERM, formDate['policyHolder.holderIdStartDate'] === '9999-99-99')
this.$store.commit(types.UPDATE_ISINSUREDIDLONGTERM, formDate['policyInsuredList[0].insuredIdStartDate'] === '9999-99-99')
this.$store.commit(types.UPDATE_HOLDERIDENDTERM, formDate['policyHolder.holderIdEffective'])
this.$store.commit(types.UPDATE_INSUREDIDENDTERM, formDate['policyInsuredList[0].insuredIdEffective'])
this.$store.commit(types.UPDATE_HOLDERPHONE, formDate['policyHolder.holderPhone'])
this.$store.commit(types.UPDATE_HOLDERPHONECAPTCHA, formDate.verificationCode)
this.$store.commit(types.UPDATE_HOLDEREMAIL, formDate['policyHolder.holderEmail'])
this.$store.commit(types.UPDATE_HOLDERAREA, formDate['policyHolder.holderArea'].split(','))
this.$store.commit(types.UPDATE_HOLDERADDRESS, formDate['policyInsuredList[0].insuredAddress'])
this.$store.commit(types.UPDATE_INSUREDNAME, formDate['policyInsuredList[0].insuredName'])
this.$store.commit(types.UPDATE_INSUREDIDNUMBER, formDate['policyInsuredList[0].insuredIdNumber'])
this.$store.commit(types.UPDATE_COVERAGE, formDate['policyInsuredList[0].coverageMultiples'])
this.$store.commit(types.UPDATE_PAYMENTPERIOD, formDate['policyInsuredList[0].insurePayWay'])
window.$('.selected-occupation').attr('code', window.sessionStorage.getItem('holderOccupationNameCode'))

console.log(window, window.$)





this.getFee()
window.$('.selected-occupation').html(window.sessionStorage.getItem('holderOccupationName'))
}, 1000)
}
}
},
data () {
return {
CAPTCHACountdown: 0,
formatDate: formatDate,
showLogin: false,
underwritingType: 'offline',
nextSend: false,
channelCode: 2
}
},
watch: {
offlineCode: function (newValue, oldValue) {
if (newValue !== '') this.getFee()
}
},
computed: {
isAeonlifeUnderwriting () {
return window.sessionStorage.getItem('fit') === 'false' && this.isAeonlife()
},
content () {
if (this.isAeonlifeUnderwriting) {
return '提交投保信息'
}
return '提交订单'
},
h5 () {
return this.$store.state.app.h5
},
offlineCode: {
get () {
return this.$store.state.order.offlineCode
},
set (value) {
this.$store.commit(types.UPDATE_ORDER_OFFLINECODE, value)
}
},
ChinaAddressData () {
if (!this.$store.state.config.form.holderArea.supports) return ChinaAddressV2Data
const supports = this.$store.state.config.form.holderArea.supports.split(',')
const newData = []
ChinaAddressV2Data.forEach((ele, index) => {
if (ele.parent === undefined) {
let inc = false
for (let i = 0, j = supports.length; i < j; i++) {
if (ele.name.indexOf(supports[i]) !== -1) {
inc = true
break
}
}
if (inc) {
newData.push(ele)
}
} else {
newData.push(ele)
}
})
return newData
},
feeSuccess () {
return this.$store.state.order.feeSuccess
},
forms () {
if (this.$store.state.config.policy) {
return this.$store.state.config.policy.forms
}
},
holderName: {
get () {
return this.$store.state.order.holderName
},
set (value) {
this.$store.commit(types.UPDATE_HOLDERNAME, value.trim())
}
},
holderIDNumber: {
get () {
return this.$store.state.order.holderIDNumber
},
set (value) {
this.$store.commit(types.UPDATE_HOLDERIDNUMBER, value.trim().toUpperCase())
}
},
isHolderIDLongTerm: {
get () {
return this.$store.state.order.isHolderIDLongTerm
},
set (value) {
this.$store.commit(types.UPDATE_ISHOLDERIDLONGTERM, value)
}
},
holderIDBeginTerm: {
get () {
return this.$store.state.order.holderIDBeginTerm
},
set (value) {
this.$store.commit(types.UPDATE_HOLDERIDBEGINTERM, value)
}
},
holderIDEndTerm: {
get () {
return this.$store.state.order.holderIDEndTerm
},
set (value) {
this.$store.commit(types.UPDATE_HOLDERIDENDTERM, value)
}
},
holderOccupation: {
get () {
return this.$store.state.order.holderOccupation
},
set (value) {
this.$store.commit(types.UPDATE_HOLDEROCCUPATION, value)
}
},
isInsuredIDLongTerm: {
get () {
return this.$store.state.order.isInsuredIDLongTerm
},
set (value) {
this.$store.commit(types.UPDATE_ISINSUREDIDLONGTERM, value)
}
},
insuredIDBeginTerm: {
get () {
return this.$store.state.order.insuredIDBeginTerm
},
set (value) {
this.$store.commit(types.UPDATE_INSUREDIDBEGINTERM, value)
}
},
insuredIDEndTerm: {
get () {
return this.$store.state.order.insuredIDEndTerm
},
set (value) {
this.$store.commit(types.UPDATE_INSUREDIDENDTERM, value)
}
},
holderPhone: {
get () {
return this.$store.state.order.holderPhone
},
set (value) {
this.$store.commit(types.UPDATE_HOLDERPHONE, value.trim())
}
},
holderPhoneCAPTCHA: {
get () {
return this.$store.state.order.holderPhoneCAPTCHA
},
set (value) {
this.$store.commit(types.UPDATE_HOLDERPHONECAPTCHA, value.trim())
}
},
CAPTCHALabel () {
if (this.CAPTCHACountdown === 0) {
return '获取'
}
return this.CAPTCHACountdown + '秒'
},
holderEmail: {
get () {
return this.$store.state.order.holderEmail
},
set (value) {
this.$store.commit(types.UPDATE_HOLDEREMAIL, value)
}
},
holderArea: {
get () {
return this.$store.state.order.holderArea
},
set (value) {
this.$store.commit(types.UPDATE_HOLDERAREA, value)
}
},
holderAddress: {
get () {
return this.$store.state.order.holderAddress
},
set (value) {
this.$store.commit(types.UPDATE_HOLDERADDRESS, value.trim())
}
},
insuredRelations () {
const insuredRelations = []
if (this.$store.state.config.form) {
this.$store.state.config.form.insuredRelations.list.forEach(ele => {
insuredRelations.push({
name: ele.name,
value: ele.value
})
})
}
return insuredRelations
},
insuredRelation: {
get () {
return this.$store.state.order.insuredRelation
},
set (value) {
this.$store.commit(types.UPDATE_INSUREDRELATION, value)
}
},
insuredName: {
get () {
return this.$store.state.order.insuredName
},
set (value) {
this.$store.commit(types.UPDATE_INSUREDNAME, value.trim())
}
},
insuredIDNumber: {
get () {
return this.$store.state.order.insuredIDNumber
},
set (value) {
this.$store.commit(types.UPDATE_INSUREDIDNUMBER, value.trim().toUpperCase())
}
},
insuredHeight: {
get () {
return this.$store.state.order.insuredHeight
},
set (value) {
this.$store.commit(types.UPDATE_INSUREDHEIGHT, value.trim())
}
},
insuredWeight: {
get () {
return this.$store.state.order.insuredWeight
},
set (value) {
this.$store.commit(types.UPDATE_INSUREDWEIGHT, value.trim())
}
},
coverages () {
const coverages = []
this.$store.state.config.form.coverages.list.forEach(ele => {
const tempCoverage = {
name: ele.name + '万',
value: ele.value
}

if (this.insuredIDNumber && ele.constraints) {
const age = getAgeAndSexFromID(this.insuredIDNumber).age
if (age && this.checkInsuredIDNumber(false, false) && (age.y < ele.constraints.age.begin || age.y > ele.constraints.age.end)) {
tempCoverage.accessable = false
}
}
coverages.push(tempCoverage)
})

for (let i = 0, l = coverages.length; i < l; i++) {

if (coverages[i].accessable === false) {
if (coverages[i].value === this.coverage) {
for (let i = 0, l = coverages.length; i < l; i++) {
if (coverages[i].accessable !== false) {
this.$store.commit(types.UPDATE_COVERAGE, coverages[i].value)
break
}
}
}
}
}
return coverages
},
coverage: {
get () {
return this.$store.state.order.coverage
},
set (value) {
this.$store.commit(types.UPDATE_COVERAGE, value)
}
},
paymentPeriods () {
if (this.$store.state.config.measure && this.$store.state.config.measure.status) {
const paymentPeriods = []
const age = getAgeAndSexFromID(this.insuredIDNumber).age
this.$store.state.config.form.paymentPeriods.list.forEach(ele => {
const tempPaymentPeriod = {
name: ele.value + '年',
value: ele.value
}

if (ele.constraints) {
ele.constraints.forEach(c => {
const test = {}
if (c.age && age && age.y >= c.age.begin && age.y <= c.age.end) {
test.age = true
} else {
test.age = false
}
if (c.insurancePeriods) {
test.insurancePeriods = false
c.insurancePeriods.forEach(ele => {
if (ele.value === this.insurancePeriod) {
test.insurancePeriods = true
}
})
}
let allTest = true
for (let key in test) {
if (!test[key]) allTest = false
}
if (allTest) {
tempPaymentPeriod.accessable = false
}
})
}
paymentPeriods.push(tempPaymentPeriod)
})

/**
* 特殊说明
* 百年人寿轻症豁免版 51-55周岁男性，30年交期不可选
* 150476691002746473
* 150537492578996275
*/
const sex = getAgeAndSexFromID(this.insuredIDNumber).sex
if (age !== null &&
age.y !== null &&
age.y >= 51 &&
age.y <= 55 &&
['150476691002746473', '150537492578996275'].indexOf(this.$store.state.app.productCode) !== -1 &&
sex === 1) {
paymentPeriods.forEach((ele) => {
if (ele.value === 30) {
ele.accessable = false
}
})
}


for (let i = 0, l = paymentPeriods.length; i < l; i++) {

if (paymentPeriods[i].accessable === false) {
if (paymentPeriods[i].value === this.paymentPeriod) {
for (let i = 0, l = paymentPeriods.length; i < l; i++) {
if (paymentPeriods[i].accessable !== false) {
this.$store.commit(types.UPDATE_PAYMENTPERIOD, paymentPeriods[i].value)
break
}
}
}
}
}
return paymentPeriods
}
},
paymentPeriod: {
get () {
return this.$store.state.order.paymentPeriod
},
set (value) {
this.$store.commit(types.UPDATE_PAYMENTPERIOD, value)
}
},
insurancePeriods () {
if (this.$store.state.config.measure && this.$store.state.config.measure.status) {
const insurancePeriods = []
const age = getAgeAndSexFromID(this.insuredIDNumber).age
this.$store.state.config.form.insurancePeriods.list.forEach(ele => {
const tempInsurancePeriods = {
value: ele.value.value
}
if (ele.value.type === 'age') {
tempInsurancePeriods.name = '至' + ele.value.value + '周岁'
} else if (ele.value.type === 'years') {
tempInsurancePeriods.name = ele.value.value + '年'
} else if (ele.value.type === 'lifelong') {
tempInsurancePeriods.name = '终身'
}
if (ele.constraints) {
let tests = []
ele.constraints.forEach(c => {
const test = {}
if (c.age) {
if (age && this.checkInsuredIDNumber(false, false)) {
if (age.y <= c.age.end && age.y >= c.age.begin) {
test.age = true
} else {
test.age = false
}
} else {
test.age = true
}
}
if (c.paymentPeriods) {
test.insurancePeriods = false
if (c.paymentPeriods.indexOf(this.paymentPeriod) !== -1) {
test.insurancePeriods = true
}
}
let allTest = true
for (let key in test) {
if (!test[key]) allTest = false
}
tests.push(allTest)
})
if (tests.indexOf(true) === -1) {
tempInsurancePeriods.accessable = false
}
}
insurancePeriods.push(tempInsurancePeriods)
})

for (let i = 0, l = insurancePeriods.length; i < l; i++) {

if (insurancePeriods[i].accessable === false) {
if (insurancePeriods[i].value === this.insurancePeriod) {
for (let i = 0, l = insurancePeriods.length; i < l; i++) {
if (insurancePeriods[i].accessable !== false) {
this.$store.commit(types.UPDATE_INSURANCEPERIOD, insurancePeriods[i].value)
break
}
}
}
}
}
return insurancePeriods
}
},
insurancePeriod: {
get () {
return this.$store.state.order.insurancePeriod
},
set (value) {
this.$store.commit(types.UPDATE_INSURANCEPERIOD, value)
}
},
paymentWays () {
const paymentWays = []
this.$store.state.config.form.paymentWays.list.forEach(ele => {
paymentWays.push({
name: ele.name,
value: ele.value
})
})
return paymentWays
},
paymentWay: {
get () {
return this.$store.state.order.paymentWay
},
set (value) {
this.$store.commit(types.UPDATE_PAYMENTWAY, value)
}
},
paymentModes () {
const paymentModes = []
this.$store.state.config.form.paymentModes.list.forEach(ele => {
paymentModes.push({
name: ele.name,
value: ele.value
})
})
return paymentModes
},
paymentMode: {
get () {
return this.$store.state.order.paymentMode
},
set (value) {
this.$store.commit(types.UPDATE_ORDER_PAYMENTMODE, value)
}
},
copiesMin () {
const copiesMinLength = this.$store.state.config.form.copies.min.length
for (let i = 0; i < copiesMinLength; i++) {
if (this.$store.state.config.form.copies.min[i].paymentMode === this.paymentMode) {
return this.$store.state.config.form.copies.min[i].value
}
}
},
copiesMax () {
const copiesMaxLength = this.$store.state.config.form.copies.max.length
for (let i = 0; i < copiesMaxLength; i++) {
if (this.$store.state.config.form.copies.max[i].paymentMode === this.paymentMode) {
return this.$store.state.config.form.copies.max[i].value
}
}
},
insuredOccupation: {
get () {
return this.$store.state.order.insuredOccupation
},
set (value) {
this.$store.commit(types.UPDATE_INSUREDOCCUPATION, value)
}
},
mild: {
get () {
return this.$store.state.order.mild
},
set (value) {
this.$store.commit(types.UPDATE_MILD, value)
}
},
mildCoverage () {
return (this.coverage * this.$store.state.config.form.mildCoverage.rate) + '万'
},
paymentUnit () {
if (this.$store.state.order.paymentMode === 1) {
return '年'
} else if (this.$store.state.order.paymentMode === 2) {
return '月'
}





if (this.$store.state.config.paymentUnit) return this.$store.state.config.paymentUnit
},
number () {
if (this.feeSuccess === false) {
/**
* 年交和月交
* 最小额度不同
*/
if (this.$store.state.config.form && this.$store.state.config.form.paymentModes) {
const length = this.$store.state.config.form.paymentModes.list.length
for (let i = 0; i < length; i++) {
if (this.$store.state.config.form.paymentModes.list[i].value === this.$store.state.order.paymentMode) {
console.log(this.$store.state.config.form.paymentModes.list[i].minPremium)
return this.$store.state.config.form.paymentModes.list[i].minPremium
}
}
}
console.log(this.$store.state.config.minPremium)
return this.$store.state.config.minPremium
}
if (this.$store.state.order.copies) {
console.log(this.$store.state.measure.basePremium * this.$store.state.order.coverage * this.$store.state.order.copies / 100)
return this.$store.state.measure.basePremium * this.$store.state.order.coverage * this.$store.state.order.copies / 100
}
return this.$store.state.measure.basePremium * this.$store.state.order.coverage / 100
},
agreement () {
if (this.$store.state.config.policy && this.$store.state.config.policy.agreement) {
return this.$store.state.config.policy.agreement
}
},
backMoney () {
const backMoney = this.$store.state.measure.baseBackMoney * this.$store.state.order.coverage / 100
return backMoney
},
backMoneyStr () {
return '每' + (this.paymentMode === 1 ? '年' : '月') + '可领取' + this.backMoney + '元至终身'
}
},
methods: {

addDate () {
alert(123)
const formDate = sessionStorage.getItem('data')
console.log(formDate)
},
getQueryString (name) {
this.url = location.hash
this.arrObj = this.url.split('?')
this.arrPara = this.arrObj[1].split('&')
for (let i = 0; i < this.arrPara.length; i++) {
this.arr = this.arrPara[i].split('=')
if (this.arr[0] === name) {
if (this.arr != null) return decodeURIComponent(this.arr[1])
}
}
},
launchCommon () {
if (String(this.$route.params.innerCode) === '148198068433580000') {
this.channelCode = 1
} else if (this.h5 !== false) {
this.channelCode = 3
}
this.launchData = {anchorCode: 1, channelCode: this.channelCode, linkedProductCode: this.$route.params.productCode, orderSource: this.getQueryString('utm_source'), utSource: this.getQueryString('hmsr'), phoneNumber: this.holderPhone, personName: this.holderName, identityCard: this.holderIDNumber, verifyCode: this.holderPhoneCAPTCHA}
this.$http.post('/api/pageView/savePageViewRecord', qs.stringify(this.launchData)).then((response) => {})
},
submitOrder () {
/**
* 这个厉害
*/





const checkers = []
this.$store.state.config.policy.forms.forEach(form => {
form.form.forEach(item => {
const ele = this.$store.state.config.form[item.type]
if (item.type !== 'cell' && ele && ele.check) {
checkers.push('check' + ele.storeKey.replace(ele.storeKey[0], ele.storeKey[0].toUpperCase()))
}
})
})
for (let i = 0; i < checkers.length; i++) {
if (!this[checkers[i]]()) return
}










































if (this.insuredRelation === 3) {
const holderAge = getAgeAndSexFromID(this.holderIDNumber).age.y
const insuredAge = getAgeAndSexFromID(this.insuredIDNumber).age.y
if (holderAge - insuredAge < 18) {
this.$vux.toast.show({
type: 'text',
text: '客官，子女和父母年龄差距不得小于18岁',
position: 'top',
width: '20em'
})
return false
}
}
if (this.insuredRelation === 4) {
const holderAge = getAgeAndSexFromID(this.holderIDNumber).age.y
const insuredAge = getAgeAndSexFromID(this.insuredIDNumber).age.y
if (insuredAge - holderAge < 18) {
this.$vux.toast.show({
type: 'text',
text: '客官，子女和父母年龄差距不得小于18岁',
position: 'top',
width: '20em'
})
return false
}
}
if (this.insuredRelation === 2) {
const holderSex = getAgeAndSexFromID(this.holderIDNumber).sex
const insuredSex = getAgeAndSexFromID(this.insuredIDNumber).sex
if (holderSex === insuredSex) {
this.$vux.toast.show({
type: 'text',
text: '客官，配偶的性别不能相同哦',
position: 'top',
width: '20em'
})
return false
}
}












this.$store.commit(types.UPDATE_INSUREDOCCUPATION, {
code: this.$refs.insuredOccupation ? this.$refs.insuredOccupation[0].getAttribute('code') : '',
name: this.$refs.insuredOccupation ? (this.$refs.insuredOccupation[0].innerText || this.$refs.insuredOccupation[0].textContent) : ''
})

const data = {
'productCode': this.$store.state.app.productCode,
'policyHolder.holderName': this.holderName,
'policyHolder.holderIdNumber': this.holderIDNumber,
'policyHolder.holderIdStartDate': this.isHolderIDLongTerm ? '9999-99-99' : this.holderIDBeginTerm,
'policyHolder.holderIdEffective': this.isHolderIDLongTerm ? '9999-99-99' : this.holderIDEndTerm,
'policyHolder.holderPhone': this.holderPhone,
'verificationCode': this.holderPhoneCAPTCHA,
'policyHolder.holderEmail': this.holderEmail,
'policyHolder.holderArea': this.holderArea[0] + ',' + this.holderArea[1] + ',' + this.holderArea[2],
'policyHolder.holderAddress': this.holderAddress,
'policyHolder.holderOccupation': this.$refs.holderOccupation ? this.$refs.holderOccupation[0].getAttribute('code') : '',
'policyHolder.holderIdType': '1',
'policyHolder.holderNationality': 'CHN',
'policyInsuredList[0].holdInsRelation': this.insuredRelation,
'policyInsuredList[0].insuredName': this.insuredName,
'policyInsuredList[0].insuredIdType': '1',
'policyInsuredList[0].insuredIdNumber': this.insuredIDNumber,
'policyInsuredList[0].insuredIdStartDate': this.isInsuredIDLongTerm ? '9999-99-99' : this.insuredIDBeginTerm,
'policyInsuredList[0].insuredIdEffective': this.isInsuredIDLongTerm ? '9999-99-99' : this.insuredIDEndTerm,
'policyInsuredList[0].insuredHeight': this.insuredHeight,
'policyInsuredList[0].insuredWeight': this.insuredWeight,
'policyInsuredList[0].insuredOccupation': this.$refs.insuredOccupation ? this.$refs.insuredOccupation[0].getAttribute('code') : '',
'policyInsuredList[0].coverageMultiples': this.coverage, // 保额
'policyInsuredList[0].insurePayWay': this.paymentPeriod, // 交费期间
'policyInsuredList[0].durationPeriodValue': this.insurancePeriod, // 保险期间
'policyInsuredList[0].insuredAddress': this.holderAddress,

'innerCode': this.$store.state.app.innerCode, // innerCode
'additionalRiskCodes': this.$store.state.order.mild ? this.$store.state.config.form.mild.default : '',
'policyInsuredList[0].payMode': this.$store.state.order.paymentMode

}
if (this.$route.query.activityCode) {
data.activityCode = this.$route.query.activityCode
}
if (this.$route.query.agentCode) {
data.agentCode = this.$route.query.agentCode
}
this.$store.state.config.form.insurancePeriods.list.forEach(ele => {
if (this.$store.state.order.insurancePeriod === ele.value.value) {
data['policyInsuredList[0].durationPeriodType'] = ele.value.typeCode
}
})

if (this.$route.query.utm_source) {
data['orderSource'] = this.$route.query.utm_source
}
if (this.$route.query.utm_media) {
data['utmMedia'] = this.$route.query.utm_media
}
if (this.$route.query.utm_campaign) {
data['utmCampaign'] = this.$route.query.utm_campaign
}
if (this.$route.query.utm_term) {
data['utmTerm'] = this.$route.query.utm_term
}
if (this.$route.query.utm_content) {
data['utmContent'] = this.$route.query.utm_content
}

if (this.offlineCode !== '') {
data['offlineCode'] = this.offlineCode

}
this.$vux.loading.show({
text: '正在提交'
})
let goInsurePolicy = '/api/illness/goInsurePolicy'
if (this.h5) {
data.merchantCode = this.$store.state.app.innerCode
for (let i in this.$route.query) {
data[i] = this.$route.query[i]
}
goInsurePolicy = '/api/channel/illness/goInsurePolicy'
}
if (this.nextSend) {
console.log('重复提交的时候')
return
}

if (this.$store.state.app.productCode === '150634119420883220' || this.$store.state.app.productCode === '150631164164706555') {
sessionStorage.setItem('data', JSON.stringify(data))
sessionStorage.setItem('holderOccupationName', window.$('.selected-occupation').html())
sessionStorage.setItem('holderOccupationNameCode', window.$('.selected-occupation').attr('code'))
sessionStorage.setItem('number', this.number)
sessionStorage.setItem('holderName', data['policyHolder.holderName'])
if (this.paymentPeriod * this.number > 200000) {
const _this = this
window.location.href = '/products/' + _this.$store.state.app.productCode + '/feedbackid' + '?innerCode=' + _this.$store.state.app.innerCode + '&typeIndex=3&unionCode'
return
}
}
this.nextSend = true
if (this.isAeonlifeUnderwriting) {
const _this = this

_this.$http.get('/api/insurance/offlineUnderwriting/verify/' + _this.insuredIDNumber).then(response => {
let verifyData = response.data
if (verifyData === 'offline') {
window.sessionStorage.setItem('isoffline', 'offline')
data.underwritingType = 'offline'
data.syncIndication = 'Y'
this.$http.post(goInsurePolicy, qs.stringify(data)).then((response) => {
this.$vux.loading.hide()
this.nextSend = false
let resultfit = response.data
let flagtype = typeof resultfit

if (response.data.code === 400) {
this.showLogin = true
return false
}
if (!response.data.unionOrderCode) {
this.$vux.toast.show({
type: 'text',
text: '客官，' + response.data.substring(6),
position: 'top',
width: '20em'
})
return false
}
if (flagtype === 'string') {
_this.$vux.confirm.show({
title: '投保失败',
content: '<p>' + resultfit.slice(6) + '</p>',
confirmText: '咨询客服',
cancelText: '取消',
onCancel () {
},
onConfirm () {
window.location.href = 'tel:4006612992'
}
})
} else {
if (resultfit.resultMsg && resultfit.resultMsg === 'success') {
window.location.href = '/aeonlife/underwriting/detail?productCode=' + _this.$store.state.app.productCode + '&innerCode=' + _this.$store.state.app.innerCode + '&unionOrderCode=' + resultfit.unionOrderCode + '&price=' + this.number + '&query=' + encodeURIComponent(qs.stringify(_this.$route.query))
} else {
_this.$vux.confirm.show({
title: '投保失败',
content: '<p>' + resultfit.resultMsg.slice(6) + '</p>',
confirmText: '咨询客服',
cancelText: '取消',
onCancel () {
},
onConfirm () {
window.location.href = 'tel:4006612992'
}
})
}
}
})
} else if (verifyData === 'online') {
window.sessionStorage.setItem('isoffline', 'online')
data.underwritingType = ''
data.syncIndication = ''
this.$http.post(goInsurePolicy, qs.stringify(data)).then((response) => {
this.$vux.loading.hide()
this.nextSend = false

if (response.data.code === 400) {
this.showLogin = true
return false
}
if (!response.data.unionOrderCode) {
this.$vux.toast.show({
type: 'text',
text: '客官，' + response.data.substring(6),
position: 'top',
width: '20em'
})
return false
}
this.$store.commit(types.UPDATE_ORDER_UNIONCODE, response.data.unionOrderCode)
this.$router.push({name: 'Order', params: {productCode: this.$store.state.app.productCode, innerCode: this.$store.state.app.innerCode, unionCode: this.$store.state.order.unionCode}, query: this.$route.query})
})
} else if (verifyData.indexOf('ERROR') !== -1) {
this.$vux.toast.show({
type: 'text',
text: verifyData.slice(6),
position: 'top',
width: '20em'
})
this.nextSend = false
return false
}
})
} else {
this.$http.post(goInsurePolicy, qs.stringify(data)).then((response) => {
this.$vux.loading.hide()

this.nextSend = false
if (response.data.code === 400) {
this.showLogin = true
return false
}
if (!response.data.unionOrderCode) {
this.$vux.toast.show({
type: 'text',
text: '客官，' + response.data.substring(6),
position: 'top',
width: '20em'
})
return false
}
this.$store.commit(types.UPDATE_ORDER_UNIONCODE, response.data.unionOrderCode)
this.$router.push({name: 'Order', params: {productCode: this.$store.state.app.productCode, innerCode: this.$store.state.app.innerCode, unionCode: this.$store.state.order.unionCode}, query: this.$route.query})
})
}
},
checkHolderName () {
if (this.holderName === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请输入投保人姓名',
position: 'top',
width: '20em'
})
return false
}

if (!/^[\u4E00-\u9FA5]{2,12}$/.test(this.holderName)) {
this.$vux.toast.show({
type: 'text',
text: '客官，请填写正确的投保人姓名',
position: 'top',
width: '20em'
})
return false
}
if (this.insuredRelation === 1) {
this.insuredName = this.holderName
}
return true
},
checkHolderIDNumber () {
if (this.holderIDNumber === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请填写投保人身份证号',
position: 'top',
width: '20em'
})
return false
}

if (!Verify.verifyIDNumber(this.holderIDNumber)) {
this.$vux.toast.show({
type: 'text',
text: '客官，请填写正确的投保人身份证号',
position: 'top',
width: '20em'
})
return false
}

if (getAgeAndSexFromID(this.holderIDNumber).age.y < 18) {
this.$vux.toast.show({
type: 'text',
text: '客官，投保人年龄需在18岁及以上哦',
position: 'top',
width: '20em'
})
return false
}
if (this.insuredRelation === 1) {
this.insuredIDNumber = this.holderIDNumber
this.getFee()
}
return true
},
changeHolderIDLongTerm () {
if (this.insuredRelation === 1) {
this.isInsuredIDLongTerm = this.isHolderIDLongTerm
}
},
changeHolderIDBeginTerm () {
if (this.insuredRelation === 1) {
this.insuredIDBeginTerm = this.holderIDBeginTerm
}
},
changeHolderIDEndTerm () {
if (this.insuredRelation === 1) {
this.insuredIDEndTerm = this.holderIDEndTerm
}
},
checkHolderIDBeginTerm () {

if (!this.isHolderIDLongTerm) {
if (!this.holderIDBeginTerm) {
this.$vux.toast.show({
type: 'text',
text: '客官，请选择投保人身份证有效起期',
position: 'top',
width: '20em'
})
return false
}
}
return true
},
checkHolderIDEndTerm () {

if (!this.isHolderIDLongTerm) {
if (!this.holderIDEndTerm) {
this.$vux.toast.show({
type: 'text',
text: '客官，请选择投保人身份证有效止期',
position: 'top',
width: '20em'
})
return false
}
}
return true
},
checkInsuredIDBeginTerm () {

if (!this.isInsuredIDLongTerm) {
if (!this.insuredIDBeginTerm) {
this.$vux.toast.show({
type: 'text',
text: '客官，请选择被投保人身份证有效起期',
position: 'top',
width: '20em'
})
return false
}
}
return true
},
checkInsuredIDEndTerm () {

if (!this.isInsuredIDLongTerm) {
if (!this.insuredIDEndTerm) {
this.$vux.toast.show({
type: 'text',
text: '客官，请选择被投保人身份证有效止期',
position: 'top',
width: '20em'
})
return false
}
}
return true
},
checkHolderPhone () {
if (this.holderPhone === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请输入手机号',
position: 'top',
width: '20em'
})
return false
}
if (!/^1[23456789]\d{9}$/.test(this.holderPhone)) {
this.$vux.toast.show({
type: 'text',
text: '客官，请正确输入手机号',
position: 'top',
width: '20em'
})
return false
}
return true
},
checkHolderPhoneCAPTCHA () {
if (this.holderPhoneCAPTCHA === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请输入验证码',
position: 'top',
width: '20em'
})
return false
}
if (!/^\d{4}$/.test(this.holderPhoneCAPTCHA)) {
this.$vux.toast.show({
type: 'text',
text: '客官，请正确输入验证码',
position: 'top',
width: '20em'
})
return false
}
if (this.checkHolderPhone()) {
this.launchCommon()
}
return true
},
sendCAPTCHA () {
if (this.checkHolderPhone()) {
const that = this
const utmSourcePhone = 'wechat170913'
const random = Math.random()
const needBusParam = this.holderPhone + '?utm_source_phone=' + utmSourcePhone + '&v=' + random
let sendMessageCode = '/api/common/sendMessageCodeNew/' + this.holderPhone + '?v=' + random + '&serviceName=' + window.hex_md5(needBusParam)
if (this.h5) sendMessageCode = '/api/channel/illness/sendMessageCodeNew/' + this.$store.state.app.productCode + '/' + this.$store.state.app.innerCode + '/' + this.holderPhone
this.$http.get(sendMessageCode)
.then(response => {
if (response.data.statusCode === '000000') {
that.CAPTCHACountdown = 60
const CAPTCHATimer = setInterval(() => {
if (that.CAPTCHACountdown === 0) {
clearInterval(CAPTCHATimer)
} else {
that.CAPTCHACountdown--
}
}, 1000)
} else {
this.$vux.toast.show({
type: 'text',
text: response.data.statusMsg,
position: 'top',
width: '20em'
})
}
})
}
},
checkHolderEmail () {
if (this.holderEmail === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请输入个人电子邮箱',
position: 'top',
width: '20em'
})
return false
}
if (!/^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/.test(this.holderEmail)) {
this.$vux.toast.show({
type: 'text',
text: '客官，请正确输入个人电子邮箱',
position: 'top',
width: '20em'
})
return false
}
return true
},
checkHolderArea () {
if (this.holderArea.length === 0) {
this.$vux.toast.show({
type: 'text',
text: '客官，请选择所在地区',
position: 'top',
width: '20em'
})
return false
}
return true
},
checkHolderAddress () {
if (this.holderAddress === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请输入详细地址',
position: 'top',
width: '20em'
})
return false
}








if (this.holderAddress.length < 7) {
this.$vux.toast.show({
type: 'text',
text: '客官，详细地址需大于等于7个字符',
position: 'top',
width: '20em'
})
return false
}
if (this.$store.state.config.form.holderAddress.check.max) {
if (this.holderAddress.length > this.$store.state.config.form.holderAddress.check.max) {
this.$vux.toast.show({
type: 'text',
text: '客官，详细地址需小于等于' + this.$store.state.config.form.holderAddress.check.max + '个字符',
position: 'top',
width: '20em'
})
return false
}
}
if (this.holderAddress.match(/\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]/g) !== null) {
this.$vux.toast.show({
type: 'text',
text: '客官，请正确输入详细地址',
position: 'top',
width: '20em'
})
return false
}
if (/[,，&]/.test(this.holderAddress)) {
this.$vux.toast.show({
type: 'text',
text: '客官，请正确输入详细地址',
position: 'top',
width: '20em'
})
return false
}
return true
},
checkInsuredName () {
if (this.insuredName === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请输入被保人姓名',
position: 'top',
width: '20em'
})
return false
}

if (!/^[\u4E00-\u9FA5]{2,12}$/.test(this.insuredName)) {
this.$vux.toast.show({
type: 'text',
text: '客官，请填写正确的被保人姓名',
position: 'top',
width: '20em'
})
return false
}
return true
},
checkInsuredIDNumber (needFeeAction, showToast) {
if (this.insuredIDNumber === '') {
if (showToast !== false) {
this.$vux.toast.show({
type: 'text',
text: '客官，请填写被保人身份证号',
position: 'top',
width: '20em'
})
}
return false
}

if (!Verify.verifyIDNumber(this.insuredIDNumber)) {
if (showToast !== false) {
this.$vux.toast.show({
type: 'text',
text: '客官，请填写正确的被保人身份证号',
position: 'top',
width: '20em'
})
}
return false
}

let illegal = null
this.$store.state.config.form.insuredRelations.list.forEach(ele => {
if (ele.value === this.insuredRelation) {
const age = getAgeAndSexFromID(this.insuredIDNumber).age
if (ele.age.beginAge.unit === 'd') {
let beginAgeValue = ele.age.beginAge.value
if (ele.age.beginAge.include) {
beginAgeValue -= 1
}
if (age.y === 0 && age.d < beginAgeValue) {
illegal = ele
}
} else {
if (age.y < ele.age.beginAge.value) {
illegal = ele
}
}
if (ele.age.endAge.unit === 'd') {
if (age.y === 0 && age.d > ele.age.endAge.value) {
illegal = ele
}
} else {
if (age.y > ele.age.endAge.value) {
illegal = ele
}
}
}
})
if (illegal) {
if (showToast !== false) {
this.$vux.toast.show({
type: 'text',
text: '客官，' + illegal.name + '投保年龄' + illegal.age.beginAge.value + (illegal.age.beginAge.unit === 'y' ? '周岁' : '天') + '-' + illegal.age.endAge.value + (illegal.age.endAge.unit === 'y' ? '周岁' : '天'),
position: 'top',
width: '20em'
})
}
return false
}

if (this.$store.state.config.form.insuredOccupation.constraints && this.$store.state.config.form.insuredOccupation.constraints.length > 0) {

const age = getAgeAndSexFromID(this.insuredIDNumber).age
const insuredRelation = this.insuredRelation
this.$store.state.config.form.insuredOccupation.constraints.forEach(ele => {
const testers = []

if (ele.insuredRelation) {
if (ele.insuredRelation === insuredRelation) {
testers.push(true)
} else {
testers.push(false)
}
}

if (ele.age) {
if (isAgeIn(age, ele.age)) {
testers.push(true)
} else {
testers.push(false)
}
}

if (testers.length === 0 || testers.indexOf(false) === -1) {
this.$store.commit(types.UPDATE_INSUREDOCCUPATION, ele.value)
}
})
}

if (needFeeAction !== false) this.getFee()
return true
},
checkInsuredHeight () {
if (this.insuredHeight === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请填写被保人身高',
position: 'top',
width: '20em'
})
return false
}
if (!/^\d+?$/.test(this.insuredHeight)) {
this.$vux.toast.show({
type: 'text',
text: '客官，请正确填写被保人身高',
position: 'top',
width: '20em'
})
return false
}
const age = getAgeAndSexFromID(this.insuredIDNumber).age
if (age && age.y > 17 && Number(this.insuredHeight) < 140) {
this.$vux.toast.show({
type: 'text',
text: '客官，17周岁及以上的被保人身高不得低于140cm哦',
position: 'top',
width: '20em'
})
return false
}
return true
},
checkInsuredWeight () {
if (this.insuredWeight === '') {
this.$vux.toast.show({
type: 'text',
text: '客官，请填写被保人体重',
position: 'top',
width: '20em'
})
return false
}
if (!/^\d+?$/.test(this.insuredWeight)) {
this.$vux.toast.show({
type: 'text',
text: '客官，请正确填写被保人体重',
position: 'top',
width: '20em'
})
return false
}
if (this.checkInsuredHeight()) {
const bmi = this.insuredWeight / ((this.insuredHeight / 100) * (this.insuredHeight / 100))
if (bmi >= 28) {
this.$vux.toast.show({
type: 'text',
text: '客官，被保人的BMI不得大于等于28哦',
position: 'top',
width: '20em'
})
return false
}
}
return true
},
changeRnsuredRelation () {

this.$store.commit(types.UPDATE_INSUREDNAME, '')

this.$store.commit(types.UPDATE_INSUREDIDNUMBER, '')
this.$store.commit(types.UPDATE_INSUREDIDBEGINTERM, '')
this.$store.commit(types.UPDATE_INSUREDIDENDTERM, '')

if (this.insuredRelation === 1) {
this.insuredName = this.holderName
this.insuredIDNumber = this.holderIDNumber
this.isInsuredIDLongTerm = this.isHolderIDLongTerm
this.insuredIDBeginTerm = this.holderIDBeginTerm
this.insuredIDEndTerm = this.holderIDEndTerm
}


this.$store.commit(types.UPDATE_INSUREDHEIGHT, '')
this.$store.commit(types.UPDATE_INSUREDWEIGHT, '')

for (let i = 0, l = this.$store.state.config.form.coverages.list.length; i < l; i++) {
if (this.$store.state.config.form.coverages.list[i].default) {
this.$store.commit(types.UPDATE_COVERAGE, this.$store.state.config.form.coverages.list[i].value)
break
}
}

for (let i = 0, l = this.$store.state.config.form.paymentPeriods.list.length; i < l; i++) {
if (this.$store.state.config.form.paymentPeriods.list[i].default) {
this.$store.commit(types.UPDATE_PAYMENTPERIOD, this.$store.state.config.form.paymentPeriods.list[i].value)
break
}
}

for (let i = 0, l = this.$store.state.config.form.insurancePeriods.list.length; i < l; i++) {
if (this.$store.state.config.form.insurancePeriods.list[i].default) {
this.$store.commit(types.UPDATE_INSURANCEPERIOD, this.$store.state.config.form.insurancePeriods.list[i].value.value)
break
}
}

for (let i = 0, l = this.$store.state.config.form.paymentWays.list.length; i < l; i++) {
if (this.$store.state.config.form.paymentWays.list[i].default) {
this.$store.commit(types.UPDATE_PAYMENTWAY, this.$store.state.config.form.paymentWays.list[i].value)
break
}
}

const copiesValueLength = this.$store.state.config.form.copies.value.length
for (let i = 0; i < copiesValueLength; i++) {
if (this.$store.state.config.form.copies.value[i].paymentMode === this.paymentMode) {
this.$store.commit(types.UPDATE_COVERAGE, this.$store.state.config.form.copies.value[i].value)
}
}
this.getFee()
},
changePaymentMode () {
const copiesValueLength = this.$store.state.config.form.copies.value.length
for (let i = 0; i < copiesValueLength; i++) {
if (this.$store.state.config.form.copies.value[i].paymentMode === this.paymentMode) {
this.$store.commit(types.UPDATE_COVERAGE, this.$store.state.config.form.copies.value[i].value)
}
}
this.getFee()
},
getFee () {


setTimeout(() => {
if (!this.checkInsuredIDNumber(false)) {
this.$store.commit(types.UPDATE_FEESUCCESS, false)
return
}

const data = {
productCode: this.$store.state.app.productCode,
sex: getAgeAndSexFromID(this.insuredIDNumber).sex,
age: getAgeAndSexFromID(this.insuredIDNumber).age.y,
payType: this.$store.state.order.paymentPeriod,
durationPeriodValue: this.$store.state.order.insurancePeriod,
additionalRiskCodes: this.$store.state.order.mild ? this.$store.state.config.form.mild.default : '',
payMode: this.$store.state.order.paymentMode,
innerCode: this.$store.state.app.innerCode,
utm_source: this.$route.query.utm_source || ''
}
this.$store.state.config.form.insurancePeriods.list.forEach(ele => {
if (this.$store.state.order.insurancePeriod === ele.value.value) {
data.durationPeriodType = ele.value.typeCode
}
})
this.$http.get('/api/illness/getFee?' + qs.stringify(data)).then(response => {
if (response.data !== false) {
this.$store.commit(types.UPDATE_FEESUCCESS, true)
console.log(response.data.coverage)
if (response.data.coverage) {
this.$store.commit(types.UPDATE_BASEPREMIUM, response.data.money)
this.$store.commit(types.UPDATE_BASEBACKMONEY, response.data.coverage)
} else {
this.$store.commit(types.UPDATE_BASEPREMIUM, response.data)
}
}
})
}, 0)
},
closeLogin () {
this.showLogin = false
this.submitOrder()
},
insureMsg () { // 有的情况下的点击事件
const a = true
const _this = this
if (a) {
this.$router.push({name: 'Pay'})

} else {
_this.$vux.confirm.show({
title: '投保失败',
content: '<p>核保失败原因<p>',
confirmText: '咨询客服',
cancelText: '取消',
onCancel () {
},
onConfirm () {
window.location.href = 'tel:4006612992'
}
})
}
},
isAeonlife () {
if (['150476691002746473', '150537492578996275', '150570517523511386', '150546537968917914'].indexOf(this.$store.state.app.productCode) !== -1) {
return true
}
return false
}
}
}



// WEBPACK FOOTER //
// ./src/components/Form.vue